import { AccordionDetailsProps } from '@mui/material';

import { useFormikContext } from 'formik';

import { DefaultAccordion, DefaultAccordionEnum } from 'app/components';

interface Props extends AccordionDetailsProps {
  title: string;
  checked: boolean;
  elements: any[];
  icon: React.ReactNode;
  type: DefaultAccordionEnum;
  amountSelected: number;
  active?: boolean;
}

export function RoleArrcordion(props: Props) {
  const { values, setFieldValue }: any = useFormikContext();

  const handleClickAll = (add: boolean) => {
    if (props.type === DefaultAccordionEnum.SEMESTER) {
      let semesters = [...values.semesters] as string[];
      props.elements.forEach(element => {
        if (add) {
          if (!semesters.includes(element)) {
            semesters.push(element);
          }
        } else {
          if (semesters.includes(element)) {
            semesters.splice(semesters.indexOf(element), 1);
          }
        }
      });
      setFieldValue('semesters', semesters);
    } else {
      let recipients = [...values.recipients] as string[];
      props.elements.forEach(element => {
        if (add) {
          if (!recipients.includes(element.entitlement)) {
            recipients.push(element.entitlement);
          }
        } else {
          if (recipients.includes(element.entitlement)) {
            recipients.splice(recipients.indexOf(element.entitlement), 1);
          }
        }
      });
      setFieldValue('recipients', recipients);
    }
  };

  return (
    <DefaultAccordion
      {...props}
      handleClickAll={handleClickAll}
      amountSelected={props.amountSelected}
    />
  );
}
